export default __webpack_public_path__ + "static/media/arrow-left-circle.d4fa4cdc.svg";